/* eslint max-classes-per-file: 0 */

import {
  Procedure as Data,
  ProcedureCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'
import { Procedure } from '@/typings/api/Procedure'

export class ProceduresApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'procedures';

  protected readonly hasFinishSlash = false;
}

export class ProceduresPublicationsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'procedures/publications';

  protected readonly hasFinishSlash = false;
}

export class ProceduresApiUpdate extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'procedures';

  protected readonly hasFinishSlash = false;

  public updateProcedure(procedure_id: Procedure['id'], data: Record<string, unknown>, config: AxiosRequestConfig = {}) {
    const path = `/${procedure_id}/update`
    const [url] = this.getUrl(path)
    return this.request('POST', url, { data, ...config })
  }
}
